<template>
  <div class="calc-package-select">
    <ul
      class="nav calc-package-select__nav"
    >
      <li>
        <a
          class="nav__item"
          :class="{ 'active': selectTab === 'box' }"
          @click="selectTab = 'box'"
        >
          Короб
        </a>
      </li>
      <li>
        <a
          class="nav__item"
          :class="{ 'active': selectTab === 'package' }"
          @click="selectTab = 'package'"
        >
          Пакет
        </a>
      </li>
      <li>
        <a
          class="nav__item"
          :class="{ 'active': selectTab === 'letter' }"
          @click="selectTab = 'letter'"
        >
          Конверт
        </a>
      </li>
    </ul>
    <div class="calc-package-select__content">
      <div class="calc-package-select__left">
        <CalcPackageItem
          v-for="packageItem in packages[selectTab]"
          :key="packageItem.name"
          :name="packageItem.name"
          :size="packageItem.size"
          :desc="packageItem.desc"
          :package-id="packageItem.packageId"
          :img-name="packageItem.imgName"
          :active="packageItem.packageId === packageSelectedId"
          class="calc-package-select__item"
          @click.native="() => onPackageClick(packageItem, selectTab)"
        />
      </div>
      <div
        v-if="!isMobile"
        class="calc-package-select__right">
        <img
          :src="'https://storage.yandexcloud.net/boxberrysite-public/calculator_pip/' + packageImageId +'.svg'"
          alt="package"
          loading="lazy"
        >
      </div>
    </div>
  </div>
</template>

<script>
import deviceInfo from '../../../helpers/device';
import CalcPackageItem from './CalcPackageItem.vue';
import { getters as packageSelectedGetters } from '../../../store/package-selected.store';

export default {
  name: 'CalcPackageSelect',
  components: { CalcPackageItem },
  data: () => ({
    selectTab: 'box',
    packages: {
      box: [
        {
          desc: 'Мобильный телефон, украшения, духи',
          packageId: '000000799',
          name: 'Короб XS',
          size: '(15 x 15 x 10см)',
          imgName: 'box-xs'
        }, {
          desc: 'Книга, платье, канцелярия',
          packageId: '000000798',
          name: 'Короб S',
          size: '(20 x 20 x 14см)',
          imgName: 'box-s'
        }, {
          desc: 'Рюкзак, детские игрушки, джинсы',
          packageId: '000000797',
          name: 'Короб M',
          size: '(35 x 20 x 14см)',
          imgName: 'box-m'
        }, {
          desc: 'Ноутбук, планшет, куртка',
          packageId: '000000801',
          name: 'Короб L',
          size: '(35 x 30 x 25см)',
          imgName: 'box-l'
        }, {
          desc: 'Принтер, компьютер',
          packageId: '000000802',
          name: 'Короб XL',
          size: '(50 x 40 x 30см)',
          imgName: 'box-xl'
        }, {
          desc: 'Ноутбук или мелкая электроника',
          packageId: '000000804',
          name: 'Короб TL',
          size: '(80 x 15 x 20см)',
          imgName: 'box-tl'
        },
      ],
      package: [
        {
          desc: 'Книга',
          packageId: '000000796',
          name: 'Пакет с клапаном XS',
          size: '(24 x 24см)',
          imgName: 'package-xs'
        }, {
          desc: 'Перчатки',
          packageId: '000000795',
          name: 'Пакет с клапаном S',
          size: '(24 x 32см)',
          imgName: 'package-s'
        }, {
          desc: 'Туфли',
          packageId: '000000794',
          name: 'Пакет с клапаном M',
          size: '(30 x 40см)',
          imgName: 'package-m'
        }, {
          desc: 'Костюм',
          packageId: '000000793',
          name: 'Пакет с клапаном L',
          size: '(39 x 51см)',
          imgName: 'package-l'
        }, {
          desc: 'Детский комбинезон',
          packageId: '000000978',
          name: 'Пакет с клапаном XL',
          size: '(60 x 75см)',
          imgName: 'package-xl'
        },
      ],
      letter: [
        {
          desc: 'Пакет документов формата А4',
          packageId: '000000800',
          name: 'Конверт А4',
          size: '(30 x 21см)',
          imgName: 'letter-a4'
        },
      ],
      activeTabSelected: '',
      packageImageId: 'package-xs',
    },
  }),
  computed: {
    ...deviceInfo,
    ...packageSelectedGetters,
    packageSelectedId() {
      return packageSelectedGetters.package_id();
    },
  },
  watch: {
    selectTab: {
      handler(val) {
        if (val && val !== this.activeTabSelected) {
          this.packageImageId = this.packages[this.selectTab][0].imgName;
          this.activeTabSelected = val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    onPackageClick(packageItem, selectTab) {
      this.$emit('select', {
        name: packageItem.name,
        package_id: packageItem.packageId,
      });
      this.activeTabSelected = selectTab;
      this.packageImageId = packageItem.imgName;
    },
  },
};
</script>

<style lang="scss" scoped>
.nav.calc-package-select__nav {
  margin-bottom: 24px;
}
.calc-package-select__item {
  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
}
.calc-package-select__content {
  display: flex;
}
.calc-package-select__left {
  flex-grow: 1;
}
.calc-package-select__left {
  @media (min-width: 1051px) {
    flex-basis: 50%;
    margin-right: 6px;
  }
}
.calc-package-select__right {
  margin-left: 6px;
  display: flex;
  flex-basis: 50%;
  align-items: center;
  justify-content: center;
  width: 50%;
  border-radius: 8px;
  border: 1px solid rgba(159, 179, 195, 0.5);
  background-color: #fff;
  @media (max-width: 1199px) {
    display: none;
  }
  img {
    width: 80%;
  }
}
</style>
